import { render, staticRenderFns } from "./FootballFilters.vue?vue&type=template&id=6f60474f&"
import script from "./FootballFilters.vue?vue&type=script&lang=js&"
export * from "./FootballFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports